import corporateIdent from "./corporate-identity.png";
import largeScaleProj from "./large-scale-project.png";
import ownIdea from "./own-idea.png";
import whatCosts from "./what-costs-should-you-expect.png";
import whatCustom from "./what-is-all-that-you-can-customize.png";
import whyIdivFp from "./why-choose-a-customized-floor-plan.png";

export {
  corporateIdent,
  largeScaleProj,
  ownIdea,
  whatCosts,
  whatCustom,
  whyIdivFp,
};
